import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { UiSwitchModule } from 'ngx-ui-switch';

import { TaskModalModule } from '../task-modal/task-modal.module';
import { ToDoModalComponent } from './todo-modal.component';

@NgModule({
  declarations: [ToDoModalComponent],
  imports: [
    CommonModule,
    UiSwitchModule,
    ReactiveFormsModule,
    CKEditorModule,
    TaskModalModule,
    NgxBootstrapIconsModule,
  ],
  exports: [ToDoModalComponent],
})
export class ToDoModalModule {}
